import { render } from "./index.vue?vue&type=template&id=637a03cf&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=637a03cf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-637a03cf"

export default script